import { render, staticRenderFns } from "./QuotationWebSite.vue?vue&type=template&id=f5f19d98&scoped=true&"
import script from "./QuotationWebSite.vue?vue&type=script&lang=js&"
export * from "./QuotationWebSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f19d98",
  null
  
)

export default component.exports